var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen"},[_c('ContentfulGlobalBanner'),_vm._v(" "),_c('Navigation'),_vm._v(" "),_c('ContentfulGlobalBanner2'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('Footer',{staticClass:"mt-auto"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }